import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('a-row', [_vm.current >= 0 ? _c('a-col', {
    staticClass: "mt-50",
    attrs: {
      "span": 16,
      "offset": 4
    }
  }, [_c('tip'), _c('a-steps', {
    attrs: {
      "current": _vm.current
    }
  }, [_c('a-step', {
    attrs: {
      "title": _vm.t('添加主体')
    }
  }), _c('a-step', {
    attrs: {
      "title": _vm.t('信息认证/确认')
    }
  }), _c('a-step', {
    attrs: {
      "title": _vm.t('审核')
    }
  }), _c('a-step', {
    attrs: {
      "title": _vm.t('签约/完成')
    }
  })], 1)], 1) : _vm._e()], 1), _c('a-row', [_c(_vm.componentName, {
    tag: "component",
    attrs: {
      "data": _vm.data,
      "startupInfoLoading": _vm.loading
    },
    on: {
      "submit": _vm.handleSubmit
    }
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };